var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-6",attrs:{"fluid":""}},[_c('DatatableV2',{attrs:{"displayTitle":false,"flat":false,"url":_vm.apiUrl},on:{"copyApiToken":_vm.copyApiToken}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }